import { render } from "./TelemetryView.vue?vue&type=template&id=0a52ed40"
import script from "./TelemetryView.vue?vue&type=script&lang=js"
export * from "./TelemetryView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__